import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";
import { apiRequest } from "@/helper/api";
import {
  OCCUPATIONAL_MEDICINE_COMPANY_APPOINTMENT_CONFIRMATION_KEY,
  isOccupationalMedicineCategory,
} from "@/components/appointment/occupationalMedicineCompanyAppointmentConfirmation";

const categoryIsOccupationalMedicine = async (
  categoryId: string,
): Promise<boolean> => {
  if (isOccupationalMedicineCategory(categoryId)) {
    return true;
  }
  const response = await apiRequest({
    entity: "mainCategory",
    method: "get",
    entityId: categoryId,
  });
  return isOccupationalMedicineCategory(response.data); // the form holds the id of the latest category version, only the category itself tells its trace id
};

const subjectIsCompany = async (subjectId: string): Promise<boolean> => {
  const response = await apiRequest({
    entity: "subject",
    method: "get",
    entityId: subjectId,
  });
  return response.data?.is_company === true;
};

export const appointmentEntityAdapter: EntityAdapter = {
  entity: "appointment",
  searchAutoFocus: false,
  confirmCreate: async (result, { confirm }) => {
    if (!result?.category || !result?.subject) {
      return true;
    }
    if (!(await categoryIsOccupationalMedicine(String(result.category)))) {
      return true;
    }
    if (!(await subjectIsCompany(String(result.subject)))) {
      return true;
    }
    return confirm(OCCUPATIONAL_MEDICINE_COMPANY_APPOINTMENT_CONFIRMATION_KEY);
  },
};
